<template>
  <div>
    <template v-if="showServices">
      <div v-if="$is_mobile_view" class="w-100 my-4" style="height: 8px; background-color: #eee"></div>
      <div 
        class="w-100 bg-white"
        :class="$is_mobile_view ? 'ga-container fluid' : 'p-4 box-shadow-main rounded-6 border-form mb-4'"
        >
        <div class="d-flex align-items-center mb-4">
          <svg :width="$is_mobile_view ? '24' : '40'" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.14628 35.2054L1.64404 40.3013C1.9227 41.1824 2.28843 41.8216 2.77608 42.288L5.04015 40.8196C4.43058 40.5777 4.03002 40.0941 3.80362 39.2995L2.63675 35.0154C2.54968 34.739 2.65417 34.549 2.95024 34.549H36.737C37.033 34.549 37.1201 34.7909 36.9112 35.0154L33.1494 39.2821C32.5572 39.9387 32.087 40.4915 31.0421 40.7851L33.1668 42.3399C34.0725 41.7179 34.769 40.8541 35.6747 39.8349L39.4365 35.5509C40.6731 34.1171 39.7674 32.1997 37.7645 32.1997H2.3581C0.459766 32.1997 -0.35878 33.4779 0.14628 35.2054ZM16.7262 33.6507H19.0773V1.17467C19.0773 0.535509 18.5374 0 17.893 0C17.2486 0 16.7262 0.535509 16.7262 1.17467V33.6507ZM18.0672 27.7083H25.2251C30.4674 27.7083 33.3758 25.048 33.3758 20.7466C33.3758 13.4223 25.7129 5.18234 18.5723 1.4856L17.3706 3.50673C23.2919 6.06335 31.0247 13.7332 31.0247 20.3839C31.0247 23.3897 28.8999 25.3589 25.2425 25.3589H18.0672V27.7083ZM19.5302 4.59502C25.3122 12.8177 23.4487 22.8197 17.9801 25.5663L18.4679 27.6047C25.9392 24.2016 27.7156 13.4568 21.5504 4.24952L19.5302 4.59502ZM4.36093 27.7083H17.6319V25.3589H6.62498C6.416 25.3589 6.32891 25.1517 6.50307 25.0308C12.4593 20.5739 17.9627 10.3129 18.8684 3.28215L16.7262 1.81382C16.8655 7.63533 11.3795 18.7083 3.38564 24.4608C1.6963 25.6872 2.63675 27.7083 4.36093 27.7083ZM18.4503 44.1536C23.1874 44.1536 23.9538 40.6469 26.7055 40.6469C29.5443 40.6469 29.9971 44.1536 35.4308 44.1536H37.1898C37.869 44.1536 38.4263 43.6008 38.4263 42.9271C38.4263 42.2535 37.869 41.7179 37.1898 41.7179H35.4308C33.5499 41.7179 32.505 40.9405 31.1813 40.0249C30.0493 39.2132 28.6386 38.2112 26.7055 38.2112C24.7201 38.2112 23.2919 39.2649 22.1425 40.1113C20.9582 41.0096 20.0004 41.7179 18.4503 41.7179C16.8829 41.7179 15.925 41.0096 14.7408 40.1113C13.5913 39.2649 12.1632 38.2112 10.1778 38.2112C8.24467 38.2112 6.83398 39.2132 5.70194 40.0249C4.37833 40.9405 3.33339 41.7179 1.45247 41.7179H1.36539C0.686172 41.7179 0.14628 42.2535 0.14628 42.9271C0.14628 43.6008 0.686172 44.1536 1.36539 44.1536H1.45247C6.88622 44.1536 7.33903 40.6469 10.1778 40.6469C12.9295 40.6469 13.6958 44.1536 18.4503 44.1536Z" fill="#222"/>
          </svg>
          <div class="ml-md-4 ml-3">
            <p 
              class="mb-0" 
              :class="$is_mobile_view ? 'body-1-4' : 'heading-6-1'">Transport</p>
            <p 
              class="mb-0"
              :class="$is_mobile_view ? 'body-3-3-1' : 'body-2-2'">Make your stay even better</p>
          </div>
        </div>
        <div class="w-100 border-b-form d-flex mb-4">
          <p 
            class="px-3 py-2 mb-0 cursor-pointer" 
            :class="{
              'border-bottom-orange-3 text-green font-bold' : rt.code === routeType.code,
              'body-2': !$is_mobile_view,
              'body-3': $is_mobile_view
            }" 
    
            v-for="rt in routeTypeOptionsDisplay" @click="selectRouteType(rt)">{{ rt.label }}</p>
        </div>
        <div :class="productIndex + 1 < products.length ? 'mb-4' : ''" v-for="(product, productIndex) in products">
          <TransportServicesProduct :product="product" @detail="togglePopupProduct" />
        </div>
    
        <b-modal
          size="md"
          hide-header
          hide-footer
          body-class="p-0"
          centered
          @hidden="togglePopupProduct(null)"
          v-model="productPopup.show">
          <div class="w-100 rounded-6 overflow-hidden">
            <TransportServicesProductDetail 
              v-if="productPopup.show" 
              :product="productPopup.data" 
              @close="togglePopupProduct"
              />
          </div>
        </b-modal>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { get } from '@/services/index.js'
  import TransportServicesProduct from './TransportServicesProduct.vue';
  import TransportServicesProductDetail from './TransportServicesProductDetail.vue';

  export default {
    components:{
      TransportServicesProduct,
      TransportServicesProductDetail
    },
    data(){
      return{
        routeTypeOptions: [
          { code: 'ROUNDTRIP', label: 'Round Trip', show: false},
          { code: 'PICKUP', label: 'Pick Up', show: false},
          { code: 'DROPOFF', label: 'Drop Off', show: false},
        ],
        routeType: {},
        isLoad: true,
        errorMessage: '',
        allProducts: [],
        showServices: true,
        productPopup:{
          show: false,
          data: {}
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      routeTypeOptionsDisplay(){
        const totalShow = this.routeTypeOptions.filter(rt => rt.show);
        return totalShow.length < 2 ? [] : totalShow;
      },
      products(){
        if(this.$isEmpty(this.routeType)) return [];
        return this.allProducts.filter(product => product.cm_transport_route_type === this.routeType.code);
      }
    },
    mounted(){
      this.loadProductList();
    },
    methods:{
      selectRouteType(routeType){
        this.routeType = routeType;
      },
      togglePopupProduct(data = null){
        if(data === null){
          this.productPopup = { show: false, data: {} }
        }else{
          this.productPopup = { show: true, data }
        }
      },
      async loadProductList(){
        this.isLoad = true;
        this.errorMessage = '';

        try {

          const apiParams = {
            merchant_id: this.getMerchant.id,
            category_id: 'ALL',
            use_cm_transport: 'true',
          }
          const apiResponse = await get('CORE_HOTEL', 'hotel-additional-service', apiParams);
          const { success, message, data } = apiResponse.data;
          if(!success) throw new Error(message);
          if(this.$isEmpty(data)){
            this.showServices = false
            return;
          }
          this.allProducts = this.parsingProduct(data);
          this.getRouteType(data);
          
        } catch (error) {
          this.errorMessage = error.message;
        } finally {
          this.isLoad = false
        }
      },
      getRouteType(products){
        let routeType = [];
        for (let i = 0; i < products.length; i++) {
          if(routeType.length == 3) return;
          
          const { cm_transport_route_type: route_type = null } = products[i];
          if(route_type === null) continue;
          
          const isRouteTypeMatch = routeType.some(rt => rt === route_type);
          if(isRouteTypeMatch) continue;
          routeType.push(route_type);
        }

        
        this.routeTypeOptions = this.routeTypeOptions.map(rt => {
          rt.show = routeType.some(_rt => _rt === rt.code);
          return rt;
        });
        this.routeType = this.routeTypeOptionsDisplay[0];
      },
      parsingProduct(products){
        const generateRouteType = (code) => {
          const selectedRoute = this.routeTypeOptions.find(rt => rt.code === code);
          if(!selectedRoute) return '';
          
          const isRoundTrip = code === 'ROUNDTRIP';
          const lastText = isRoundTrip ? 'transfer' : 'only';
          return `${selectedRoute.label} ${lastText}`;
        }
        
        return products.map(product => {
          const { cm_transport_pax_category: pax = null, cm_transport_route_type: routeType = null } = product;
          
          product.display = {
            routeType: generateRouteType(routeType),
            passenger: this.$isEmpty(pax) ? 'All passenger categories' : `${this.$capitalize(pax)} passengers`
          }
          
          return product;
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/TransportServices.vue